import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

import TaskCard from './TaskCard';

function TaskColumn({
  status,
  tasks,
  statusOptions,
  onEdit,
  onStatusChange,
  onToggleComplete,
  onDelete,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        minWidth: 320,
        maxWidth: 360,
        flex: '0 0 320px',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: { xs: 'unset', lg: 'calc(100vh - 260px)' },
      }}
    >
      <CardHeader
        titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600 }}
        title={`${status.label} (${tasks.length})`}
      />
      <Divider />
      <CardContent sx={{ flexGrow: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2, pb: 3 }}>
        {tasks.length === 0 ? (
          <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              No tasks here yet
            </Typography>
          </Stack>
        ) : (
          tasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              statusOptions={statusOptions}
              onEdit={onEdit}
              onStatusChange={onStatusChange}
              onToggleComplete={onToggleComplete}
              onDelete={onDelete}
            />
          ))
        )}
      </CardContent>
    </Card>
  );
}

TaskColumn.propTypes = {
  status: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  tasks: PropTypes.arrayOf(PropTypes.object),
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onEdit: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onToggleComplete: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

TaskColumn.defaultProps = {
  tasks: [],
};

export default TaskColumn;
